import { ChartBarIcon } from '@heroicons/react/24/outline'

const PerformanceReportIcon = () => <ChartBarIcon width={24} height={24} stroke="#A88CA4" />

export default PerformanceReportIcon
